import { render, staticRenderFns } from "./ppvview.vue?vue&type=template&id=013c77aa&scoped=true&"
import script from "./ppvview.vue?vue&type=script&lang=js&"
export * from "./ppvview.vue?vue&type=script&lang=js&"
import style0 from "./ppvview.vue?vue&type=style&index=0&id=013c77aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c77aa",
  null
  
)

export default component.exports